export const products = [
  {
    id: 1,
    name: "Nusa Weave Sling",
    category: "Fashion",
    description: "Handwoven sling bag featuring traditional Dayak motifs, perfect for modern everyday use.",
    image: "https://ik.imagekit.io/dandie/sapuyung%20dare/Woven%20Sling%20Bag.PNG"
  },
  {
    id: 2,
    name: "Dayak Mask",
    category: "Fashion",
    description: "Contemporary face mask with authentic Dayak patterns, blending tradition with daily essentials.",
    images: [
      "https://ik.imagekit.io/dandie/sapuyung%20dare/Dayak%20Mask.PNG",
      "https://ik.imagekit.io/dandie/sapuyung%20dare/Dayak%20Mask2.PNG"
    ]
  },
  {
    id: 3,
    name: "Andau Steps",
    category: "Fashion",
    description: "Comfortable footwear adorned with Sapuyung Dare motifs, bringing heritage to every step.",
    images: [
      "https://ik.imagekit.io/dandie/sapuyung%20dare/Andau%20Steps.PNG",
      "https://ik.imagekit.io/dandie/sapuyung%20dare/Andau%20Steps2.PNG",
      "https://ik.imagekit.io/dandie/sapuyung%20dare/Andau%20Steps3.PNG"
    ]
  },
  {
    id: 4,
    name: "Borneo Sip Tumbler",
    category: "Lifestyle",
    description: "Insulated tumbler featuring traditional weave patterns for your daily hydration.",
    image: "https://ik.imagekit.io/dandie/sapuyung%20dare/Borneo%20Sip%20Tumbler.PNG"
  },
  {
    id: 5,
    name: "Borneo Tumbler",
    category: "Lifestyle",
    description: "Classic tumbler design with authentic Dayak motif details.",
    image: "https://ik.imagekit.io/dandie/sapuyung%20dare/Borneo%20Tumblr.PNG"
  },
  {
    id: 6,
    name: "Borneo Pattern Case",
    category: "Lifestyle",
    description: "Protect your phone with traditional Dayak artistry in a modern phone case.",
    image: "https://ik.imagekit.io/dandie/sapuyung%20dare/Borneo%20PhoneCase.PNG"
  },
  {
    id: 7,
    name: "Borneo Spirit Bracelet",
    category: "Accessories",
    description: "Handcrafted bracelet inspired by ancestral weaving traditions.",
    image: "https://ik.imagekit.io/dandie/sapuyung%20dare/Borneo%20Spirit%20Bracelet.PNG"
  },
  {
    id: 8,
    name: "Dayak Urban Cap",
    category: "Fashion",
    description: "Modern baseball cap featuring subtle traditional motif embroidery.",
    image: "https://ik.imagekit.io/dandie/sapuyung%20dare/Dayak%20Urban%20Cap.PNG"
  }
];

export const motifs = [
  {
    name: "Antang Tawit",
    meaning: "Soaring hope"
  },
  {
    name: "Tajim Hepeng",
    meaning: "Blessings & abundance"
  },
  {
    name: "Lambang Palangka",
    meaning: "Human origin"
  },
  {
    name: "Suluh Petuk Danum",
    meaning: "New life"
  },
  {
    name: "Liau Baguti",
    meaning: "The spirit realm"
  },
  {
    name: "Burung Dahiang",
    meaning: "Misfortune flying away"
  },
  {
    name: "Tunggul Balu",
    meaning: "The soul's final pause"
  },
  {
    name: "Sawang",
    meaning: "Prosperity & honor"
  },
  {
    name: "Mata Andau",
    meaning: "Modern reinterpretation inspired by the sun and horizon",
    type: "Innovated Motif"
  }
];